import { useContext } from 'react'
import { useLocation } from 'react-router-dom'
import Context from '../Context'
import EventMarkets from '../components/EventMarkets'

/**
 * Every line of one event, on its own screen. The screen is only the address: which event, and which book
 * it was opened for. What it draws lives in EventMarkets, because the search board draws the same thing
 * inside a row it has expanded.
 */
function MarketSnapshot({ pollingInterval }) {
  const { selectedEvent } = useContext(Context)
  const book = new URLSearchParams(useLocation().search).get('book')

  return <EventMarkets event={selectedEvent} book={book} pollingInterval={pollingInterval} />
}

export default MarketSnapshot
